import { SunMedium } from 'lucide-react'
import { Facebook, Twitter, Youtube } from 'react-feather'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import sLogo from '../../assets/MIND-01-01.png'

const Footer = () => {
  const tokenMetrics = [
    { id: 1, label: 'Max Supply', value: '710 000 000' },
    { id: 2, label: 'Total Supply', value: '71,000,000' },
    { id: 3, label: 'Circulating Supply', value: '519 051 439' },
    { id: 4, label: 'Total Burned', value: '44 507 511' },
    { id: 5, label: 'Market Cap', value: '$43 171 732' },
  ]

  const footerLinks = [
    {
      id: 1,
      title: 'About',
      data: [
        { id: 1, label: 'Terms of Use', path: '/terms', external: false },
        { id: 2, label: 'Privacy Policy', path: '/privacy', external: false },
        { id: 3, label: 'Blog', path: 'https://academy.mindchain.info/', external: true },
      ],
    },
    {
      id: 2,
      title: 'Features',
      data: [
        { id: 1, label: 'Exchange', path: '/exchange', external: false },
        { id: 2, label: 'Liquidity', path: '/liquidity', external: false },
        { id: 3, label: 'Farms', path: '/farms', external: false },
        { id: 4, label: 'Launchpools', path: '/launchpools', external: false },
        { id: 5, label: 'Staking', path: '/staking', external: false },
      ],
    },
    {
      id: 3,
      title: 'Services',
      data: [
        { id: 1, label: 'Referral Program', path: '/referral', external: false },
        { id: 2, label: 'MIND Token', path: '/mind-token', external: false },
        { id: 3, label: 'Apply to Launch', path: '/apply', external: false },
        { id: 4, label: 'CEX', path: 'https://mindchain.info', external: true },
        { id: 5, label: 'DeFi Wallet', path: 'https://www.mindchainwallet.com/', external: true },
      ],
    },
  ]

  const socialIcons = [
    { id: 1, icon: <Facebook />, path: 'https://www.facebook.com/mindchain.info' },
    { id: 2, icon: <Twitter />, path: 'https://x.com/MindChain1' },
    { id: 3, icon: <SunMedium />, path: 'https://medium.com/@mindchain' },
    { id: 4, icon: <Youtube />, path: 'https://www.youtube.com/@MINDCHAIN' },
  ]

  return (
    <Wrapper>
      <Container>
        {/* Token Card */}
        <TokenCard>
          <TokenTop>
            <TokenInfo>
              <Logo src={sLogo} alt="MIND" />
              <div>
                <TokenName>MIND</TokenName>
                <TokenPrice>$0.083</TokenPrice>
              </div>
            </TokenInfo>

            <Metrics>
              {tokenMetrics.map((item) => (
                <Metric key={item.id}>
                  <span>{item.label}</span>
                  <span>{item.value}</span>
                </Metric>
              ))}
            </Metrics>
          </TokenTop>

          <TokenActions>
            <WalletIcon src="https://static.biswap.org/bs/icons/metamask-transparent.svg" alt="Metamask" />
            <BuyButton href="https://mindchain.info" target="_blank" rel="noopener noreferrer">
              Buy MIND
            </BuyButton>
          </TokenActions>
        </TokenCard>

        {/* Links */}
        <LinksGrid>
          {footerLinks.map((section) => (
            <LinkColumn key={section.id}>
              <ColumnTitle>{section.title}</ColumnTitle>
              {section.data.map((link) =>
                link.external ? (
                  <ExternalLink key={link.id} href={link.path} target="_blank" rel="noopener noreferrer">
                    {link.label}
                  </ExternalLink>
                ) : (
                  <InternalLink key={link.id} to={link.path}>
                    {link.label}
                  </InternalLink>
                )
              )}
            </LinkColumn>
          ))}
        </LinksGrid>

        {/* Social */}
        <SocialSection>
          <ColumnTitle>Community</ColumnTitle>
          <SocialRow>
            {socialIcons.map((item) => (
              <SocialIcon key={item.id} href={item.path} target="_blank" rel="noopener noreferrer">
                {item.icon}
              </SocialIcon>
            ))}
          </SocialRow>
        </SocialSection>
      </Container>
    </Wrapper>
  )
}

export default Footer

/* ---------------- STYLES ---------------- */

const Wrapper = styled.footer`
  background: #1f2029;
  padding: 4rem 1rem;
  color: #fff;
`

const Container = styled.div`
  max-width: 1300px;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  @media (min-width: 1024px) {
    flex-direction: row;
    justify-content: space-between;
  }
`

/* Token Card */

const TokenCard = styled.div`
  background: #262730;
  padding: 2rem;
  border-radius: 0.75rem;
  flex: 1;
`

const TokenTop = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

const TokenInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`

const Logo = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 50%;
`

const TokenName = styled.div`
  font-size: 1rem;
  font-weight: bold;
`

const TokenPrice = styled.div`
  font-size: 0.875rem;
  color: #facc15;
`

const Metrics = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  font-size: 0.75rem;
`

const Metric = styled.div`
  display: flex;
  justify-content: space-between;
`

const TokenActions = styled.div`
  margin-top: 1.5rem;
  display: flex;
  gap: 1rem;
  align-items: center;
`

const WalletIcon = styled.img`
  width: 45px;
  height: 45px;
  padding: 0.5rem;
  background: #101010;
  border-radius: 50%;
`

const BuyButton = styled.a`
  background: #facc15;
  color: #000;
  padding: 0.6rem 1.2rem;
  border-radius: 0.5rem;
  font-weight: bold;
  text-decoration: none;
  transition: 0.3s;

  &:hover {
    opacity: 0.85;
  }
`

/* Links */

const LinksGrid = styled.div`
  display: flex;
  gap: 3rem;
  flex: 1;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`

const ColumnTitle = styled.h4`
  color: #facc15;
  margin-bottom: 0.5rem;
`

const InternalLink = styled(Link)`
  font-size: 0.85rem;
  color: #ccc;
  text-decoration: none;

  &:hover {
    color: #facc15;
  }
`

const ExternalLink = styled.a`
  font-size: 0.85rem;
  color: #ccc;
  text-decoration: none;

  &:hover {
    color: #facc15;
  }
`

/* Social */

const SocialSection = styled.div`
  flex: 1;
`

const SocialRow = styled.div`
  display: flex;
  gap: 1rem;
`

const SocialIcon = styled.a`
  font-size: 1.4rem;
  color: #fff;

  &:hover {
    color: #facc15;
  }
`
